<div class="calendar-container">
  <div class="calendar-header">
    <div class="row month-navigation" style="padding: 15px 0px;">
      <div class="col-md-4 month_section">
        <div style="margin-right: 10px;"><button class="month" (click)="prevMonth()">&#10094;</button></div>
        <div style="margin-top: 3px;font-family: var(--font);font-size: 25px;">{{ currentMonth | date: 'MMMM yyyy' }}
        </div>
        <div style="margin-left: 10px;"><button class="month" (click)="nextMonth()">&#10095;</button></div>
      </div>
      <div class="col-md-5 account_section" >
<div style="    display: inline-block;
    font-size: 18px;">Account ID : </div>
      <div class="custom-select-container">
        <mat-select [(ngModel)]="selectedAccount" id="accountSelect">
          <mat-option *ngFor="let account of SocialMediaAccountsData" [value]="account.AccountId">
            <span style="font-size: 12px;">
              <img [src]="getImagePath(account.AccountType)" [alt]="account.AccountType" class="social_icon" style="height: 24px;
    width: 24px;">
            </span>
            {{ account.AccountName }}
          </mat-option>
        </mat-select>
      </div>
      
      <button (click)="submit()" class="account_button">Select</button>
    </div>
      <div class="col-md-3 calender_button">
        <button (click)="weeks()" (click)="setView('weeks')" class="week"
          [ngClass]="{'active': currentView === 'weeks'}"
          [ngStyle]="{'background': isweekly ? 'black' : 'white', 'color': isweekly ? 'white' : 'black'}">
          Weeks
        </button>
        <button (click)="months()" (click)="setView('days')" class="week"
          [ngClass]="{'active': currentView === 'months'}"
          [ngStyle]="{'background': ismonthly ? 'black' : 'white', 'color': ismonthly ? 'white' : 'black'}">
          Months
        </button>
      </div>
      <div class="col-md-4 no_events" *ngIf="SocialMediaAccountsData.length == 0">
        No Events Available
      </div>
    </div>

  </div>
  <div class="calendar-data-wrapper">
    <div class="calender_data">
      <div class="calendar-weekday-names">
        <div class="calendar-weekday" *ngFor="let dayName of displayedWeekDays">
          {{ dayName }}
        </div>
      </div>
      <div class="calendar-grid">
        <div class="calendar-day" *ngFor="let day of (view === 'weeks' ? currentWeekDays : daysInMonth)"
          [class.selected]="day.date === selectedDate" (click)="selectDate($event, day.date)"
          [class.has-event]="day.events.length > 0">
          <div class="day-number">{{ day.date | date: 'd' }}</div>
          <!-- <div *ngIf="day.events.length > 0" class="event-names">
            <div class="event-preview">
              <img *ngIf="day.events[0].image" [src]="day.events[0].image" alt="{{ day.events[0].title }}"
                class="event-thumbnail" />
              <span>{{ day.events[0].title }}</span>
            </div>
            <div *ngIf="day.events.length > 1" class="more-events">
              +{{ day.events.length - 1 }} more
            </div>
          </div> -->
          <div *ngIf="day.events.length > 0" class="event-names">
            <div class="event-preview">
              <!-- <img *ngIf="day.events[0].EventMediaLinks" [src]="day.events[0].EventMediaLinks" alt="{{ day.events[0].EventCaption }}"
                class="event-thumbnail" /> -->
              <span [innerHTML]="getsafevalue(day.events[0].EventCaption)">{{ day.events[0].EventCaption }}</span> <!-- Display the EventCaption -->
            </div>
            <div *ngIf="day.events.length > 1" class="more-events">
              +{{ day.events.length - 1 }} more
            </div>
          </div>   
        </div>
      </div>
    </div>
  </div>




  <!-- <div *ngIf="showEvents" class="events-container">

    <h3 *ngIf="selectedDate">Events for {{ selectedDate | date: 'fullDate' }}</h3>
    <h3 *ngIf="!selectedDate">All Events</h3>

    <div *ngIf="selectedEvents.length > 0" class="events-list">
      <div *ngFor="let event of selectedEvents" class="event-item">
        <div class="event-date">
          <span class="day">{{ event.date | date: 'EEE' }}</span>
          <span class="date">{{ event.date | date: 'd' }}</span>
        </div>
        <div class="event-details">
          <div *ngIf="editingEvent && editingEvent.date.getTime() === event.date.getTime(); else viewMode">
            <input class="edit-title" [(ngModel)]="editingEvent.title" placeholder="Title" />
            <input class="edit-location" [(ngModel)]="editingEvent.location" placeholder="Location" />
            <textarea class="edit-description" [(ngModel)]="editingEvent.description"
              placeholder="Description"></textarea>
            <button class="save-button" (click)="saveEvent(event)">Save</button>
            <button class="cancel-button" (click)="cancelEdit()">Cancel</button>
          </div>

          <ng-template #viewMode>
            <p class="event-time">{{ event.date | date: 'fullDate' }} &#x2022; {{ event.time }}</p>
            <h3 class="event-title">{{ event.title }}</h3>
            <p class="event-location">{{ event.location }}</p>
            <p class="event-description">{{ event.description }}</p>


            <ng-container *ngIf="!event.accepted; else acceptedTemplate">
              <button class="accept-button" (click)="acceptEvent(event)">Accept</button>
              <button class="edit-button" (click)="editEvent(event)">Edit</button>
              <button class="decline-button" (click)="declineEvent(event)">Decline</button>
            </ng-container>


            <ng-template #acceptedTemplate>
              <span class="verified-symbol">✔ Verified</span>
            </ng-template>
          </ng-template>
        </div>

        <div *ngIf="event.image" class="event-image">
          <img [src]="event.image" alt="{{ event.title }}">
        </div>
      </div>
    </div>

    <p *ngIf="selectedEvents.length === 0">No events for this date.</p>
  </div> -->
</div>